const ArrayOfObjects = {
    sortGamesByApiDay(games) {
        let data = games;
        data = data.map(game => {
            game.dayTemp = parseInt(game.day.match(/\d/g).join(""));
            return game;
        })

        const daysInData = Array.from(new Set(data.map(game => game.dayTemp)));
        const minDay = Math.min(...daysInData);
        const maxDay = Math.max(...daysInData);
        if( maxDay - minDay > 20){
            data = data.map(game => {
                if(game.dayTemp < 15){
                    game.dayTemp += 30;
                }
                return game;
            })
        }

        data = data.sort((gameA, gameB) => {
            if(gameA.dayTemp > gameB.dayTemp){
                return 1;
            }
            if(gameA.dayTemp < gameB.dayTemp){
                return -1;
            }
            return gameA.hour > gameB.hour ? 1 : -1
        });

        return data;
    },
    shuffle(array) {
        let currentIndex = array.length;
        while (currentIndex !== 0) {
            let randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
        }
        return array;
    }
}

export default ArrayOfObjects;